import React from "react";
// import { FaFacebook, FaTwitter, FaInstagram, FaYoutube } from "react-icons/fa";
import logo from "../../assets/images/bgImage.jpg";
import { Divider, useMediaQuery } from "@mui/material";
import { YouTube } from "@mui/icons-material";
import { FaInstagram, FaLinkedin, FaYoutube } from "react-icons/fa";
import { FaFacebook, FaTwitter, FaXTwitter } from "react-icons/fa6";
import { ArrowBack } from "@mui/icons-material"; // Import back arrow icon
import { useLocation, useNavigate } from "react-router-dom";
import { s3baseUri } from "../../config/config";

export default function PartnerDetail() {
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width:600px)");
  const { state } = useLocation();
  console.log(state, "locationlocationlocation");
  const data = state.partner;
  console.log(data, "datadatadata");
  const handleNavigate = () => {
    navigate(-1);
  };

  const partner = {
    name: "Booking.com",
    sector: "Information Technology",
    sector: "Information Technology",
    location: "Dublin",
    established: "1996",
    website: "https://careers.booking.com/",
    image: logo, // Replace with the actual image path
  };

  return (
    <div className="container-fluid justify-content-center ">
      <div className="mt-3">
        <div className="card shadow-md p-4 card-padding">
          <div className="row g-4">
            {/* Left Side Content */}
            <div className="col-md-6">
              <div className="d-flex">
                {" "}
                <div
                  className=" heading-main container  mb-4 "
                  style={{ marginLeft: "0px", paddingLeft: "0px" }}
                >
                  <h2>{data.name}</h2>
                </div>
                {/* <h4
                  className="fw-bold mb-4 "
                ></h4> */}
              </div>

              <hr />

              <div
                className="info-section detail-page-text"
                style={{
                  wordWrap: "break-word",
                  overflow: "hidden",
                  maxWidth: "100%",
                }}
              >
                <p>
                  <strong>Sector</strong>{" "}
                  <span className="text-muted ms-4">{data.sector}</span>
                </p>
                <Divider />
                <p>
                  <strong>Location</strong>{" "}
                  <span className="text-muted">{data.location}</span>
                </p>
                <Divider />
                <p>
                  <strong>Established in</strong>{" "}
                  <span className="text-muted">{data.established_in}</span>
                </p>
                <Divider />
                <p>
                  <strong>Website</strong>{" "}
                  {data.website ? (
                    <a
                      href={data.website}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-primary ms-4"
                      style={{
                        wordBreak: "break-word",
                        marginLeft: isMobile ? "10px" : "",
                      }} // Prevents long URLs from breaking layout
                    >
                      {data.website}
                    </a>
                  ) : (
                    <span>no data</span>
                  )}
                </p>

                <Divider />
              </div>

              {/* Social Media Icons */}
              <div
                className="d-flex gap-4 mt-3 anchor-tag"
                style={{ justifyContent: "end" }}
              >
                {[
                  {
                    icon: <FaFacebook size={25} />,
                    url: data?.social_links?.facebook,
                    name: "Facebook",
                  },
                  {
                    icon: <FaInstagram size={25} />,
                    url: data?.social_links?.instagram,
                    name: "Instagram",
                  },
                  {
                    icon: <FaLinkedin size={25} />,
                    url: data?.social_links?.linkedin,
                    name: "LinkedIn",
                  },
                ].map((item, index) => (
                  <a
                    key={index}
                    href={item.url || "#"}
                    target={item.url ? "_blank" : ""}
                    rel={item.url ? "noopener noreferrer" : ""}
                    style={{
                      pointerEvents: item.url ? "auto" : "none",
                      opacity: item.url ? 1 : 0.5,
                    }}
                    title={item.url ? "" : `No ${item.name} link available`}
                  >
                    {item.icon}
                  </a>
                ))}
              </div>
            </div>

            {/* Right Side Image */}
            <div className="col-lg-6 col-md-6 col-sm-12 d-flex justify-content-center align-items-center">
              <img
                src={s3baseUri + data.logo}
                alt={data.name}
                className="rounded-3 shadow-sm img-fluid"
                style={{
                  maxWidth: "100%", // Ensures it doesn’t exceed the container
                  width: "auto", // Prevents stretching on larger screens
                  height: "auto", // Keeps aspect ratio intact
                  maxHeight: "300px", // Limits excessive height on large screens
                  objectFit: "contain", // Ensures the image fits without distortion
                  marginTop: "70px",
                }}
              />
            </div>
          </div>
        </div>
        <div
          className="card shadow-md p-4 mt-3 mb-4 about-content"
          style={{ marginLeft: "14px" }}
        >
          <h4 className="fw-bold mb-4  ps-2  ">About</h4>
          <p className="ps-2">{data.about}</p>
        </div>
      </div>
    </div>
  );
}
